/* Quietta Moda: side panels (menu, search, cart), accordions, carousels, product slider + variant/pack picker,
   AJAX cart, welcome pop-up and cookie consent */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const calm = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.2,.7,.2,1)';
  const money = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
  const store = { get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} } };

  /* ---------- side panels ---------- */
  const shade = document.createElement('div');
  shade.className = 'shade';
  document.body.appendChild(shade);
  $$('[data-drawer]').forEach((d) => document.body.appendChild(d)); // out of the sticky header so they stack above the shade
  let openName = null;
  const openDrawer = (name) => {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return false;
    closeDrawer();
    openName = name;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    root.classList.add('drawer-open');
    if (name === 'search') setTimeout(() => $('input', d).focus(), 250);
    return true;
  };
  const closeDrawer = () => {
    $$('[data-drawer].is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    root.classList.remove('drawer-open');
    openName = null;
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o && openDrawer(o.dataset.open)) { e.preventDefault(); return; }
    if (e.target.closest('[data-close]')) closeDrawer();
  });
  shade.addEventListener('click', closeDrawer);

  /* desktop "Productos" mega menu shares the header shade */
  const dd = $('[data-dd]');
  const hshade = $('[data-shade]');
  if (dd) {
    dd.addEventListener('toggle', () => root.classList.toggle('mega-open', dd.open));
    if (hshade) hshade.addEventListener('click', () => { dd.open = false; });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); if (dd) dd.open = false; } });

  /* ---------- search (Shopify predictive search) ---------- */
  const sform = $('[data-search]');
  if (sform) {
    const res = $('[data-search-res]');
    const hint = $('[data-search-hint]');
    let t;
    $('input', sform).addEventListener('input', (e) => {
      clearTimeout(t);
      const q = e.target.value.trim();
      if (!q) { res.innerHTML = ''; hint.hidden = false; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`).then((x) => x.json());
          const ps = r.resources.results.products || [];
          hint.hidden = ps.length > 0;
          res.innerHTML = ps.length
            ? ps.map((p) => `<a class="srch__item" href="${p.url}"><img src="${p.image || ''}" alt="" loading="lazy"><span><b>${p.title}</b>${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')
            : `<p class="srch__none">No hay resultados para «${q.replace(/[<>&]/g, '')}».</p>`;
        } catch (err) { res.innerHTML = ''; }
      }, 220);
    });
    sform.addEventListener('submit', (e) => { e.preventDefault(); const a = $('.srch__item', res); if (a) location.href = a.href; });
  }

  /* ---------- AJAX cart ---------- */
  const cartBox = $('[data-drawer="cart"]');
  const setCount = (n) => $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  /* one matching pouch per tote: the drawer (Liquid) says which pouch quantities the cart must have (data-sync);
     the pouch is a real 16,90 € product made free by an automatic "buy tote, get pouch" discount, so tampering
     with this only ever costs the customer money, never gives anything away. */
  const syncGift = async (el) => {
    if (!el || !el.dataset.sync) return false;
    let updates;
    try { updates = JSON.parse(el.dataset.sync); } catch (e) { return false; }
    const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    return r.ok;
  };
  const refreshCart = async (again = true) => {
    const r = await fetch('/?sections=moda-cart-drawer').then((x) => x.json());
    const tmp = document.createElement('div');
    tmp.innerHTML = r['moda-cart-drawer'];
    const fresh = $('[data-cart-drawer]', tmp);
    if (again && await syncGift(fresh)) return refreshCart(false);
    $('[data-cart-drawer]', cartBox).replaceWith(fresh);
    setCount(+fresh.dataset.count);
    if (!+fresh.dataset.count) { try { localStorage.removeItem('qm-res'); } catch (e) {} }
    applyCode();
    runTimer();
  };
  const cartPost = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) throw new Error('cart');
    await refreshCart();
  };
  /* reservation countdown: starts when something is added, shows "expired" when it ends (no auto restart) */
  let tick = null;
  const runTimer = () => {
    clearInterval(tick);
    const el = cartBox && $('[data-timer]', cartBox);
    if (!el) return;
    if (!store.get('qm-res')) store.set('qm-res', Date.now());
    const upd = () => {
      const left = 600 - Math.floor((Date.now() - +store.get('qm-res')) / 1000);
      if (left <= 0) {
        clearInterval(tick);
        el.classList.add('is-over');
        $('[data-timer-txt]', el).textContent = 'Tu reserva ha caducado: completa tu pedido cuanto antes para no quedarte sin él.';
        return;
      }
      $('[data-timer-left]', el).textContent = `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`;
    };
    upd();
    tick = setInterval(upd, 1000);
  };
  const applyCode = () => {
    const code = sessionStorage.getItem('qm-code');
    const a = cartBox && $('[data-checkout]', cartBox);
    if (a) a.href = code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout';
    const m = cartBox && $('[data-code-msg]', cartBox);
    if (m && code) { m.hidden = false; m.textContent = `Código ${code}: se aplicará al pagar.`; }
  };
  if (cartBox) {
    const cd0 = $('[data-cart-drawer]', cartBox);
    setCount(+cd0.dataset.count);
    if (cd0.dataset.sync) syncGift(cd0).then((ok) => { if (!ok) return; if (location.pathname.endsWith('/cart')) location.reload(); else refreshCart(false); });
    cartBox.addEventListener('click', async (e) => {
      const q = e.target.closest('[data-qty]');
      const a = e.target.closest('[data-add-id]');
      try {
        if (q) { cartBox.classList.add('is-busy'); await cartPost('/cart/change.js', { line: +q.closest('[data-line]').dataset.line, quantity: +q.dataset.qty }); }
        if (a) { cartBox.classList.add('is-busy'); store.set('qm-res', Date.now()); await cartPost('/cart/add.js', { items: [{ id: +a.dataset.addId, quantity: 1 }] }); }
      } catch (err) {}
      cartBox.classList.remove('is-busy');
    });
    cartBox.addEventListener('submit', (e) => {
      if (!e.target.matches('[data-code]')) return;
      e.preventDefault();
      const code = e.target.code.value.trim().toUpperCase();
      if (!code) return;
      sessionStorage.setItem('qm-code', code);
      applyCode();
    });
    applyCode();
    runTimer();
  }

  /* ---------- accordions (height animation on a wrapper, so padding never jumps) ---------- */
  $$('details.acc').forEach((d) => {
    const sum = $('summary', d);
    if (!sum.nextElementSibling) return;
    const box = document.createElement('div');
    box.className = 'acc__box';
    while (sum.nextSibling) box.appendChild(sum.nextSibling);
    d.appendChild(box);
    let anim = null;
    sum.addEventListener('click', (e) => {
      // FAQ: opening one closes the one that was open
      const group = d.closest('.faq__list');
      if (group && !d.open) $$('details.acc[open]', group).forEach((o) => { if (o !== d && !o.classList.contains('is-closing')) $('summary', o).click(); });
      if (calm()) return;
      e.preventDefault();
      const closing = d.open && !d.classList.contains('is-closing');
      const from = box.getBoundingClientRect().height;
      if (anim) anim.cancel();
      if (!closing) { d.open = true; d.classList.remove('is-closing'); }
      else d.classList.add('is-closing');
      const to = closing ? 0 : box.scrollHeight;
      anim = box.animate([{ height: `${from}px`, opacity: closing ? 1 : (from ? 1 : 0) }, { height: `${to}px`, opacity: closing ? 0 : 1 }], { duration: closing ? 300 : 380, easing: EASE });
      anim.onfinish = () => { anim = null; if (closing) { d.open = false; d.classList.remove('is-closing'); } };
    });
  });

  /* footer menus: drop-downs on mobile, always open on desktop */
  const ftMq = matchMedia('(min-width: 990px)');
  const ftOpen = () => $$('.ft__grp').forEach((g) => { g.open = ftMq.matches; });
  ftOpen();
  ftMq.addEventListener('change', ftOpen);

  /* ---------- carousels with arrows ---------- */
  $$('[data-carousel]').forEach((c) => {
    const track = $('[data-track]', c);
    if (!track) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300);
    const upd = () => {
      $('[data-prev]', c).disabled = track.scrollLeft < 4;
      $('[data-next]', c).disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
    };
    $('[data-prev]', c).addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-next]', c).addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', upd, { passive: true });
    upd();
  });

  /* ---------- reviews from Judge.me ----------
     data-jdgm lists products in order; the first one with 3+ written reviews fills the slider (public widget endpoint,
     same one the old store used). Cards copy the hand-made ones: photo reviews first, each naming its real product. */
  const loadReviews = async (box) => {
    const track = $('[data-track]', box);
    const shop = box.dataset.shop;
    let srcs = [];
    try { srcs = JSON.parse(box.dataset.jdgm); } catch (e) { return; }
    const api = (id, n) => `https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true&url=${shop}&shop_domain=${shop}&platform=shopify&product_id=${id}&per_page=30&page=${n}`;
    const read = async (src) => {
      const pages = await Promise.all([1].map((n) => fetch(api(src.id, n)).then((r) => r.json()).catch(() => ({}))));
      return pages.flatMap((d) => $$('.jdgm-rev', new DOMParser().parseFromString(d.html || '', 'text/html'))).map((r) => ({
        name: ($('.jdgm-rev__author', r)?.textContent || '').trim(),
        score: Number($('.jdgm-rev__rating', r)?.dataset.score) || 0,
        text: ($('.jdgm-rev__body', r)?.textContent || '').replace(/\s+/g, ' ').trim(),
        photo: ($('.jdgm-rev__pic-img', r)?.dataset.src || '').replace(/width=\d+/, 'width=600'),
        verified: r.dataset.verifiedBuyer === 'true',
        product: r.dataset.productTitle || '',
        src,
      })).filter((r) => r.name && r.text.length >= 20);
    };
    let revs = [];
    for (const src of srcs) { revs = await read(src); if (revs.length >= 3) break; }
    if (revs.length < 3) return;
    revs.sort((a, b) => !!b.photo - !!a.photo);
    const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };
    const OK = $('.rvw__ok', box)?.innerHTML || '<svg class="rvw__ok-ic" viewBox="0 0 20 21" aria-hidden="true"><circle cx="10.2" cy="10.8" r="7.5" fill="none" stroke="#555" stroke-width="1.3"/><path d="m7 11.2 2 2 4.3-4.3" fill="none" stroke="#555" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>Compra verificada';
    revs.slice(0, 12).forEach((r) => {
      const card = el('article', 'rvw__card'), body = el('div', 'rvw__body'), top = el('div', 'rvw__top');
      top.append(el('b', 'rvw__name', r.name));
      if (r.verified) { const ok = el('span', 'rvw__ok'); ok.innerHTML = OK; top.append(ok); }
      const st = el('span', 'rvw__stars', '★'.repeat(r.score));
      st.setAttribute('aria-label', r.score + ' de 5');
      if (r.score < 5) st.append(el('i', '', '★'.repeat(5 - r.score)));
      body.append(top, st, el('p', 'rvw__text', r.text));
      if (r.photo) { const ph = el('div', 'rvw__photo'); ph.append(Object.assign(document.createElement('img'), { src: r.photo, alt: r.name, loading: 'lazy', width: 600, height: 450 })); body.append(ph); }
      const foot = el('a', 'rvw__prod');
      foot.href = r.src.url;
      if (r.src.img) foot.append(Object.assign(document.createElement('img'), { src: r.src.img, alt: '', loading: 'lazy' }));
      foot.append(el('span', '', r.product));
      card.append(body, foot);
      track.append(card);
    });
    box.hidden = false;
    track.dispatchEvent(new Event('scroll'));
  };
  /* fetched only when the section is about to scroll into view (keeps the first load light on phones) */
  $$('[data-jdgm]').forEach((box) => { const io = new IntersectionObserver(([e]) => { if (!e.isIntersecting) return; io.disconnect(); loadReviews(box); }, { rootMargin: '600px 0px' }); io.observe(box.parentElement || box); });

  /* write a review: native <dialog>, posted to Judge.me's public create endpoint (form-encoded = no CORS preflight).
     Judge.me keeps it for moderation, then it shows up in the slider above by itself. */
  $$('[data-rv-dialog]').forEach((dlg) => {
    const box = dlg.closest('.rvw'), form = $('[data-rv-form]', dlg), err = $('[data-rv-err]', dlg), ok = $('[data-rv-ok]', dlg);
    $('[data-rv-open]', box)?.addEventListener('click', () => { form.hidden = false; ok.hidden = true; err.hidden = true; dlg.showModal(); });
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-rv-close]')) dlg.close(); });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const bad = !form.checkValidity() ? 'Rellena tu nombre, un email válido y una opinión de al menos 20 caracteres.' : '';
      err.textContent = bad; err.hidden = !bad;
      if (bad) return;
      const btn = $('[type=submit]', form);
      btn.disabled = true;
      const body = new URLSearchParams({ shop_domain: form.dataset.shop, platform: 'shopify', id: form.dataset.id, name: fd.get('name'), email: fd.get('email'), rating: fd.get('rating'), title: fd.get('title') || '', body: fd.get('body') });
      try {
        const r = await fetch('https://judge.me/api/v1/reviews', { method: 'POST', body });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || r.status);
        form.reset(); form.hidden = true; ok.hidden = false;
      } catch (x) {
        err.textContent = 'No se ha podido enviar (' + x.message + '). Inténtalo de nuevo en un momento.'; err.hidden = false;
      }
      btn.disabled = false;
    });
  });

  /* header shadow, reveal on scroll, count-up numbers */
  const wrap = $('[data-header]');
  if (wrap) addEventListener('scroll', () => wrap.classList.toggle('is-scrolled', scrollY > 30), { passive: true });
  const count = (el) => {
    const m = el.dataset.count.match(/^(\d+)(.*)$/);
    if (!m || calm()) return;
    el.style.minWidth = el.getBoundingClientRect().width + 'px'; // keep the final width while counting, so nothing around it moves
    const end = +m[1], rest = m[2], t0 = performance.now();
    const tick = (t) => { const k = Math.min(1, (t - t0) / 1100); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + rest; if (k < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  };
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    $$('[data-count]', e.target).forEach(count);
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -10% 0px' });
  $$('.rv').forEach((el) => io.observe(el));

  /* tab chips */
  $$('[data-tabs]').forEach((t) => t.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tab]');
    if (!b) return;
    $$('[data-tab]', t).forEach((x) => x.classList.toggle('is-on', x === b));
    $$('[data-panel]', t).forEach((p) => { p.hidden = p.dataset.panel !== b.dataset.tab; });
  }));

  /* ---------- cookie consent (Shopify Customer Privacy API) ---------- */
  const ck = $('[data-ck]');
  const withApi = (fn) => (window.Shopify && Shopify.loadFeatures
    ? Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => fn(!err && Shopify.customerPrivacy ? Shopify.customerPrivacy : null))
    : fn(null));
  let consentDone = Promise.resolve();
  if (ck) {
    consentDone = new Promise((resolve) => {
      withApi((api) => {
        const need = api ? (!api.shouldShowBanner || api.shouldShowBanner()) && api.getTrackingConsent() === 'no_interaction' : !store.get('qm-ck');
        if (!need) return resolve();
        ck.hidden = false;
        root.classList.add('ck-open');
        const behind = [...document.body.children].filter((el) => el !== ck && !el.contains(ck) && !el.inert);
        behind.forEach((el) => { el.inert = true; }); // nothing else is reachable (mouse, touch or keyboard) until they choose
        requestAnimationFrame(() => { ck.classList.add('is-in'); $('[data-ck-main]', ck)?.focus({ preventScroll: true }); });
        const prefs = $('[data-ck-prefs]', ck);
        ck.addEventListener('click', (e) => {
          const main = $('[data-ck-main]', ck);
          const open = e.target.closest('[data-ck-config]'), back = e.target.closest('[data-ck-back]');
          if (open || back) {
            main.hidden = !!open;
            prefs.hidden = !open;
            (open ? prefs : main).focus({ preventScroll: true });
            return;
          }
          const b = e.target.closest('[data-ck-choice]');
          if (!b) return;
          const all = b.dataset.ckChoice === 'all';
          const pick = (k) => all || (b.dataset.ckChoice === 'custom' && $(`[data-consent="${k}"]`, ck).checked);
          const c = { analytics: pick('analytics'), marketing: pick('marketing'), preferences: pick('preferences'), sale_of_data: pick('marketing') };
          if (api) api.setTrackingConsent(c, () => {});
          store.set('qm-ck', JSON.stringify(c));
          ck.classList.remove('is-in');
          root.classList.remove('ck-open');
          behind.forEach((el) => { el.inert = false; });
          setTimeout(() => { ck.hidden = true; resolve(); }, 300);
        });
      });
    });
  }

  /* ---------- welcome pop-up (-5% + neceser) and the "regalo misterioso" side tab ---------- */
  const pop = $('[data-pop]');
  const gtab = $('[data-gtab]');
  if (pop) {
    const tabOn = (on) => { if (gtab) gtab.hidden = !on || store.get('qm-pop') === 'done' || sessionStorage.getItem('qm-gtab') === 'x'; };
    const show = () => { tabOn(false); pop.hidden = false; requestAnimationFrame(() => pop.classList.add('is-in')); root.classList.add('pop-open'); };
    const hide = () => { pop.classList.remove('is-in'); root.classList.remove('pop-open'); setTimeout(() => { pop.hidden = true; tabOn(true); }, 300); };
    if (gtab) {
      $('[data-pop-open]', gtab).addEventListener('click', show);
      $('[data-gtab-x]', gtab).addEventListener('click', () => { sessionStorage.setItem('qm-gtab', 'x'); tabOn(false); });
    }
    const posted = /customer_posted=true/.test(location.search) && store.get('qm-pop') === 'sent';
    if (posted) {
      $('[data-pop-form]', pop).hidden = true;
      $('[data-pop-ok]', pop).hidden = false;
      store.set('qm-pop', 'done');
      consentDone.then(show);
    } else {
      consentDone.then(() => {
        tabOn(true);
        if (!store.get('qm-pop')) setTimeout(() => { if (!openName && pop.hidden) show(); }, 25000);
      });
    }
    pop.addEventListener('click', (e) => {
      if (e.target === pop || e.target.closest('[data-pop-close]')) {
        if (store.get('qm-pop') !== 'done') store.set('qm-pop', 'closed');
        hide();
      }
      const cp = e.target.closest('[data-copy]');
      if (cp) { navigator.clipboard && navigator.clipboard.writeText(cp.dataset.copy); $('span', cp).textContent = '¡Copiado!'; sessionStorage.setItem('qm-code', cp.dataset.copy); }
    });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) hide(); });
    const pf = $('form', pop);
    if (pf) pf.addEventListener('submit', () => store.set('qm-pop', 'sent'));
  }

  /* "elige el tuyo": swatches swap the big photo; on the product page the button picks that colour in the buy box */
  $$('[data-cpick]').forEach((c) => {
    const go = $('[data-cgo]', c);
    c.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-cid]');
      if (sw) {
        $$('[data-cid]', c).forEach((b) => { const on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
        $$('[data-ph]', c).forEach((im) => im.classList.toggle('is-on', im.dataset.ph === sw.dataset.cid));
        $$('[data-cname]:not([data-cid])', c).forEach((n) => { n.textContent = sw.dataset.cname; });
        go.href = sw.dataset.curl;
        go.dataset.id = sw.dataset.cid;
        return;
      }
      if (e.target.closest('[data-cgo]') && $('[data-product]')) {
        const name = $('.cl__sw.is-on', c).dataset.cname;
        const r = $(`[data-product] input[name="opt0"][value="${CSS.escape(name)}"]`);
        if (!r) return;
        e.preventDefault();
        r.click();
        scrollTo({ top: $('[data-product]').getBoundingClientRect().top + scrollY - 120, behavior: calm() ? 'auto' : 'smooth' });
      }
    });
  });

  /* photo hotspots: tap shows the label on touch screens */
  document.addEventListener('click', (e) => {
    const sp = e.target.closest('[data-spot]');
    $$('[data-spot].is-open').forEach((x) => { if (x !== sp) x.classList.remove('is-open'); });
    if (sp) sp.classList.toggle('is-open');
  });

  /* "un bolso para todo tu día": the sun walks the arc, photos and captions follow; auto-advance unless reduced motion */
  $$('[data-dia]').forEach((d) => {
    const ph = $$('[data-dia-ph]', d), caps = $$('[data-dia-cap]', d), tabs = $$('[data-dia-go]', d);
    const sun = $('[data-dia-sun]', d), done = $('[data-dia-done]', d), chip = $('[data-dia-chip]', d), bar = $('[data-dia-bar]', d);
    const n = tabs.length, STEP = 4500;
    let i = 0, timer = 0, hover = false;
    const at = (k) => 0.08 + (0.84 * k) / Math.max(1, n - 1);
    const show = (k) => {
      i = (k + n) % n;
      const t = at(i), a = Math.PI * (1 - t);
      sun.style.left = ((150 + 134 * Math.cos(a)) / 3) + '%';
      sun.style.top = ((140 - 134 * Math.sin(a)) / 1.5) + '%';
      done.style.strokeDashoffset = 100 - t * 100;
      ph.forEach((p, j) => p.classList.toggle('is-on', j === i));
      caps.forEach((c, j) => c.classList.toggle('is-on', j === i));
      tabs.forEach((b, j) => { b.classList.toggle('is-on', j === i); b.setAttribute('aria-selected', j === i); });
      chip.textContent = tabs[i].querySelector('b').textContent + ' · ' + tabs[i].querySelector('span').textContent;
      d.style.setProperty('--hue', i);
      if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; if (!calm() && !hover) bar.classList.add('is-run'); }
      clearTimeout(timer);
      if (!calm() && !hover) timer = setTimeout(() => show(i + 1), STEP);
    };
    tabs.forEach((b) => b.addEventListener('click', () => show(+b.dataset.diaGo)));
    d.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hover = true; clearTimeout(timer); bar && bar.classList.remove('is-run'); } });
    d.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hover = false; show(i); } });
    let seen = false;
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !seen) { seen = true; show(i); }
      else if (!e.isIntersecting && seen) { seen = false; clearTimeout(timer); bar && bar.classList.remove('is-run'); }
    }, { threshold: 0.3 }).observe(d);
    show(0);
  });

  /* charm pickers (tote page and cart): the photo follows the chosen colour/letter; in the cart the add button follows too */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-charm-id], [data-up-sel]');
    if (!sel || sel.tagName !== 'SELECT') return;
    const box = sel.closest('[data-charm], [data-up]');
    const img = box && box.querySelector('[data-cz-img], [data-up-img]');
    const opt = sel.selectedOptions[0];
    if (img && opt && opt.dataset.img) { img.src = opt.dataset.img; img.removeAttribute('srcset'); }
    const add = box && box.querySelector('[data-add-id]');
    if (add && sel.matches('[data-up-sel]')) add.dataset.addId = sel.value;
  });

  /* ================= product page ================= */
  const pd = $('[data-product]');
  if (!pd) return;
  const variants = JSON.parse($('[data-variants]', pd).textContent);
  const form = $('.pd__form', pd);
  const rail = $('[data-gallery]', pd);
  const slides = [...rail.children];
  const marks = $$('.pd__thumb, .pd__dot', pd);
  const add = $('[data-add]', pd);
  const cdd = $('[data-dd-color]');
  const packc = $('[data-packc]', pd);
  const packQty = +pd.dataset.t2Qty;
  const current = () => variants.find((x) => x.id == $('[data-variant-id]', form).value);
  const isPack = () => +$('input[name="tier"]:checked', form).value === packQty;

  /* slider: the rail moves with transform, following the finger or mouse, then settles on a photo */
  let idx = 0;
  const pos = (i) => -(slides[i].offsetLeft - slides[0].offsetLeft);
  const maxX = () => Math.min(0, rail.parentElement.clientWidth - rail.scrollWidth);
  const place = (x, animate) => {
    rail.style.transition = animate ? `transform ${typeof animate === 'number' ? animate : 500}ms ${EASE}` : 'none';
    rail.style.transform = `translate3d(${x}px,0,0)`;
  };
  let cycle = () => {};
  let manual = false; // the visitor moved the gallery: autoplay stops for good
  const go = (i, animate = true) => {
    idx = Math.max(0, Math.min(slides.length - 1, i));
    place(Math.max(pos(idx), maxX()), !calm() && animate);
    marks.forEach((m) => m.classList.toggle('is-on', +m.dataset.to === idx));
    cycle();
  };
  marks.forEach((m) => m.addEventListener('click', () => { manual = true; go(+m.dataset.to); }));
  let lastW = innerWidth;
  addEventListener('resize', () => { if (innerWidth === lastW) return; lastW = innerWidth; place(Math.max(pos(idx), maxX()), false); });
  let drag = null;
  rail.addEventListener('pointerdown', (e) => {
    if (e.button > 0) return;
    drag = { x: e.clientX, y: e.clientY, base: Math.max(pos(idx), maxX()), on: false, t: performance.now() };
  });
  rail.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (!drag.on) {
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) { drag = null; return; }
      if (Math.abs(dx) < 6) return;
      drag.on = true;
      rail.setPointerCapture(e.pointerId);
      rail.classList.add('is-drag');
    }
    let x = drag.base + dx;
    if (x > 0) x *= 0.35;
    if (x < maxX()) x = maxX() + (x - maxX()) * 0.35;
    place(x, false);
  });
  const end = (e) => {
    if (!drag) return;
    const was = drag;
    drag = null;
    rail.classList.remove('is-drag');
    if (!was.on) return;
    manual = true;
    const dx = e.clientX - was.x;
    const fast = Math.abs(dx) / (performance.now() - was.t) > 0.4;
    const w = slides[0].getBoundingClientRect().width;
    go(idx + ((dx < -w * 0.18 || (fast && dx < -20)) ? 1 : (dx > w * 0.18 || (fast && dx > 20)) ? -1 : 0));
  };
  rail.addEventListener('pointerup', end);
  rail.addEventListener('pointercancel', end);
  rail.addEventListener('dragstart', (e) => e.preventDefault());

  /* full-screen viewer: the magnifier (or a tap on the photo) opens the gallery at the current photo;
     a tap on a charm thumbnail in "Personaliza tu bolso" opens that charm alone. Esc / arrows / swipe work. */
  const big = (img) => { const c = (img.getAttribute('srcset') || '').split(',').map((x) => x.trim().split(' ')[0]).filter(Boolean); return c.length ? c[c.length - 1] : img.src; };
  const lb = document.createElement('div');
  lb.className = 'lb';
  lb.hidden = true;
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Foto ampliada');
  lb.innerHTML = '<div class="lb__stage"><img class="lb__img" alt=""></div><div class="lb__nav"><button type="button" class="lb__b" data-lb="-1" aria-label="Anterior"><svg class="ic" viewBox="0 0 24 24"><path d="m15 6-6 6 6 6"/></svg></button><button type="button" class="lb__b lb__x" data-lb="x" aria-label="Cerrar"><svg class="ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button type="button" class="lb__b" data-lb="1" aria-label="Siguiente"><svg class="ic" viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg></button></div>';
  document.body.appendChild(lb);
  const lbImg = $('.lb__img', lb);
  let lbList = [], lbAt = 0, lbFrom = null;
  const lbShow = (i) => { lbAt = (i + lbList.length) % lbList.length; lbImg.src = lbList[lbAt].src; lbImg.alt = lbList[lbAt].alt; };
  const lbOpen = (list, i) => {
    lbList = list;
    lbFrom = document.activeElement;
    lb.classList.toggle('lb--one', list.length < 2);
    lbShow(i);
    lb.hidden = false;
    root.style.overflow = 'hidden';
    $('.lb__x', lb).focus();
  };
  const lbClose = () => { lb.hidden = true; root.style.overflow = ''; if (lbFrom) lbFrom.focus(); };
  lb.addEventListener('click', (e) => {
    const b = e.target.closest('[data-lb]');
    if (b) return b.dataset.lb === 'x' ? lbClose() : lbShow(lbAt + +b.dataset.lb);
    if (e.target === lb || e.target.classList.contains('lb__stage')) lbClose();
  });
  addEventListener('keydown', (e) => {
    if (lb.hidden) return;
    if (e.key === 'Escape') lbClose();
    if (lbList.length > 1 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) lbShow(lbAt + (e.key === 'ArrowLeft' ? -1 : 1));
  });
  let lbX = null;
  lb.addEventListener('pointerdown', (e) => { lbX = e.clientX; });
  lb.addEventListener('pointerup', (e) => { if (lbX == null || lbList.length < 2) return; const dx = e.clientX - lbX; lbX = null; if (Math.abs(dx) > 50) lbShow(lbAt + (dx < 0 ? 1 : -1)); });
  const galleryList = () => slides.map((s) => { const im = $('img', s); return { src: big(im), alt: im.alt }; });
  $('[data-zoom]', pd)?.addEventListener('click', () => lbOpen(galleryList(), idx));
  let tapAt = null;
  rail.addEventListener('pointerdown', (e) => { tapAt = [e.clientX, e.clientY]; });
  rail.addEventListener('click', (e) => {
    if (!tapAt || Math.hypot(e.clientX - tapAt[0], e.clientY - tapAt[1]) > 6) return; // it was a swipe
    lbOpen(galleryList(), idx);
  });
  $$('.cz__img img', pd).forEach((im) => im.addEventListener('click', () => lbOpen([{ src: im.src, alt: im.alt }], 0)));

  /* autoplay: a new photo every 7 s with a slow glide (a soft fade when it loops back to the first).
     A thin bar shows the time left; it pauses while the mouse is over the photo or the tab is hidden. */
  const stage = rail.parentElement;
  const AUTO = 7000;
  const prog = document.createElement('span');
  prog.className = 'pd__prog';
  stage.appendChild(prog);
  let tbar = null, hold = false, timer = 0, left = AUTO, t0 = 0;
  const fadeTo = (i) => { stage.classList.add('is-fade'); setTimeout(() => { go(i, false); stage.classList.remove('is-fade'); }, 320); };
  const advance = () => (drag && drag.on ? cycle() : idx >= slides.length - 1 ? fadeTo(0) : go(idx + 1, 1100));
  const run = () => { clearTimeout(timer); if (manual || hold || document.hidden) return; t0 = Date.now(); timer = setTimeout(advance, left); if (tbar) tbar.play(); };
  const stop = () => { if (!timer) return; clearTimeout(timer); timer = 0; left = Math.max(0, left - (Date.now() - t0)); if (tbar) tbar.pause(); };
  cycle = () => {
    clearTimeout(timer);
    timer = 0;
    if (tbar) tbar.cancel();
    if (manual || calm() || slides.length < 2 || pd.hasAttribute('data-charm')) { prog.style.opacity = manual ? '0' : ''; return; }
    left = AUTO;
    tbar = prog.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: AUTO, easing: 'linear' });
    tbar.pause();
    run();
  };
  const pauseBar = (on) => { hold = on; on ? stop() : run(); };
  stage.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pauseBar(true); });
  stage.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') pauseBar(false); });
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : run()));

  /* price on the buttons follows colour + pack (pack shows the struck-through full price) */
  const label = () => {
    const v = current();
    const pack = isPack();
    $('[data-qty]', form).value = pack ? packQty : 1;
    const total = pack ? +pd.dataset.t2Total : v.price;
    const full = pack ? v.price * packQty : 0;
    const ok = pack ? $$('[data-packc] input:checked', pd).length === packQty : v.available;
    add.disabled = !ok;
    const price = `${full > total ? `<s>${money(full)}</s> ` : ''}${money(total)}`;
    add.innerHTML = ok ? `Añadir a la cesta <i>•</i> <span class="btn__pr"><span>${price}</span><small>IVA incluido</small></span>` : 'Agotado';
    $('[data-bar-add]').innerHTML = ok ? `Añadir <i>•</i> <span class="btn__pr"><span>${price}</span><small>IVA incluido</small></span>` : 'Agotado';
    $('[data-t1-price]', pd).textContent = money(v.price);
    const cp = $('[data-charm-price]', pd);
    if (cp) cp.textContent = money(v.price);
    if (packc) packc.classList.toggle('is-open', pack);
  };
  const packLabel = (r) => { const l = $(`[data-pc-label="${r.name.slice(2)}"]`, pd); if (l) l.textContent = r.dataset.title; };
  const jumpTo = (v) => { const m = v && ($(`[data-vid="${v.id}"]`, rail) || (v.featured_media && $(`[data-media-id="${v.featured_media.id}"]`, rail))); if (m) go(slides.indexOf(m)); };

  const promoImg = $('[data-promo-img]', pd);
  const pick = (v, jump = true) => {
    $('[data-variant-id]', form).value = v.id;
    if (promoImg) { try { const u = JSON.parse(promoImg.dataset.map)[v.id]; if (u) { promoImg.src = u; promoImg.alt = 'Neceser a juego en ' + v.title.toLowerCase(); } } catch (e) {} }
    v.options.forEach((o, i) => {
      const r = $(`input[name="opt${i}"][value="${CSS.escape(o)}"]`, form);
      if (r) r.checked = true;
      const l = $(`[data-opt-label="${i}"]`, form);
      if (l) l.textContent = o;
    });
    if (cdd) {
      $$('[role="option"]', cdd).forEach((o) => o.setAttribute('aria-selected', o.dataset.id == v.id));
      $('[data-dd-label]', cdd).textContent = v.title;
      $('[data-dd-dot]', cdd).style.background = $(`[data-id="${v.id}"]`, cdd).dataset.hex;
    }
    if (!isPack()) $$(`[data-packc] input[value="${v.id}"]`, pd).forEach((r) => { r.checked = true; packLabel(r); });
    history.replaceState(null, '', `?variant=${v.id}${location.search.includes('pack=') ? '&pack=2' : ''}`);
    if (jump) { manual = true; jumpTo(v); }
    label();
  };

  form.addEventListener('change', (e) => {
    const n = e.target.name || '';
    if (n === 'tier') return label();
    if (n.startsWith('pc')) { packLabel(e.target); jumpTo(variants.find((x) => x.id == e.target.value)); return label(); }
    const picked = $$('.pd__opt', form).map((f) => $('input:checked', f).value);
    const v = variants.find((x) => x.options.every((o, i) => o === picked[i]));
    if (v) pick(v);
  });

  /* add to cart without leaving the page, then open the cart panel */
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    let items;
    if (isPack()) {
      const counts = {};
      $$('[data-packc] input:checked', pd).forEach((r) => { counts[r.value] = (counts[r.value] || 0) + 1; });
      items = Object.entries(counts).map(([id, quantity]) => ({ id: +id, quantity }));
    } else items = [{ id: current().id, quantity: 1 }];
    add.disabled = true;
    add.textContent = 'Añadiendo…';
    try {
      store.set('qm-res', Date.now());
      await cartPost('/cart/add.js', { items });
      label();
      openDrawer('cart');
    } catch (err) {
      add.textContent = 'No se pudo añadir, inténtalo de nuevo';
      setTimeout(label, 2500);
    }
  });

  /* "personaliza tu bolso": each charm goes to the cart on its own */
  pd.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-charm-add]');
    if (!b || b.disabled) return;
    const id = $('[data-charm-id]', b.closest('[data-charm]'));
    if (!id) return;
    b.disabled = true;
    try {
      store.set('qm-res', Date.now());
      await cartPost('/cart/add.js', { items: [{ id: +id.value, quantity: 1 }] });
      b.classList.add('is-added');
      setTimeout(() => { b.classList.remove('is-added'); b.disabled = false; }, 1800);
    } catch (err) { b.disabled = false; }
  });

  if (cdd) {
    const btn = $('.dd__btn', cdd);
    const set = (open) => { cdd.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open); };
    btn.addEventListener('click', () => set(!cdd.classList.contains('is-open')));
    cdd.addEventListener('click', (e) => {
      const o = e.target.closest('[role="option"]');
      if (!o) return;
      pick(variants.find((x) => x.id == o.dataset.id));
      set(false);
    });
    document.addEventListener('click', (e) => { if (!cdd.contains(e.target)) set(false); });
  }

  if (/pack=/.test(location.search)) $(`input[name="tier"][value="${packQty}"]`, form).checked = true;
  if (!/variant=/.test(location.search)) {
    const first = +slides[0].dataset.mediaId;
    const v = variants.find((x) => x.available && x.featured_media && x.featured_media.id === first);
    if (v) pick(v, false);
  } // with ?variant= the gallery still starts on the first photo; it only moves when a colour is tapped
  if (pd.hasAttribute('data-charm')) { const m = $(`[data-vid="${current().id}"]`, rail); if (m) idx = slides.indexOf(m); }
  go(idx, false);
  label();

  const plus = (n) => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  const fmt = (d) => d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', '');
  $$('[data-eta]', pd).forEach((el) => { el.textContent = `entre el ${fmt(plus(+pd.dataset.etaMin))} y el ${fmt(plus(+pd.dataset.etaMax))}`; });

  const bar = $('[data-bar]');
  new IntersectionObserver(([e]) => bar.classList.toggle('is-in', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(add);
  $('[data-bar-add]').addEventListener('click', () => {
    if (!isPack()) return form.requestSubmit(add);
    const target = $('.opts', pd);
    scrollTo({ top: target.getBoundingClientRect().top + scrollY - 140, behavior: 'smooth' });
    packc.classList.remove('is-flash');
    void packc.offsetWidth;
    packc.classList.add('is-flash');
  });
})();
